export enum DataSourceStatus {
    Unclaimed,
    ClaimedByUser,
    ClaimedByOther,
    Error,
}